import { useMemo } from 'react';

import { DataObject } from '@mui/icons-material';

import { MergeTag } from 'domains/content/types';
import DropdownButton from 'domains/core/components/DropdownButton';
import { DropdownButtonOption } from 'domains/core/components/DropdownButton/DropdownButton';
import InputLabel from 'domains/core/components/InputLabel';
import useContactColumns from 'hooks/queries/useContactColumns';
import { getFriendlyName, getMergeTags } from 'utils';

type Props = {
    disabled?: boolean;
    handleSelect: (mergeTag: string) => void;
};

const MergeTagPicker = ({ disabled, handleSelect }: Props) => {
    const { data: contactColumns, isSuccess: isContactColumnsSuccess } = useContactColumns();

    const mergeTags = useMemo(() => {
        if (isContactColumnsSuccess) return getMergeTags(contactColumns);
    }, [contactColumns, isContactColumnsSuccess]);

    const orderedMergeTags = mergeTags?.sort((a, b) => a.value.localeCompare(b.value));
    const mergeTagOptions: DropdownButtonOption[] = orderedMergeTags?.map(({ name, value }: MergeTag) => ({
        label: <InputLabel label={getFriendlyName(name)} />,
        onClick: (): void => handleSelect(value),
    }));

    return (
        <DropdownButton
            disabled={disabled}
            data-testid="add-merge-tag"
            variant="text"
            label="Merge Tags"
            sx={{ height: 'auto', marginRight: 2, padding: '4px 8px' }}
            icon={null}
            startIcon={<DataObject sx={{ marginLeft: 0.5, marginRight: -0.25 }} />}
            options={isContactColumnsSuccess ? mergeTagOptions : []}
        />
    );
};

export default MergeTagPicker;
